import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "progress-container" }
const _hoisted_2 = { class: "progress-title w-100 d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"progress-icon d-flex align-items-center justify-content-center\"><svg width=\"46\" height=\"46\" viewBox=\"0 0 46 46\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1577_15245)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.70801 5.75H9.58301V37.375C9.58301 38.9628 8.29583 40.25 6.70801 40.25C5.12019 40.25 3.83301 38.9628 3.83301 37.375V8.625C3.83301 7.03718 5.12019 5.75 6.70801 5.75Z\" fill=\"#EF6327\"></path><path opacity=\"0.3\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.416 5.75L37.8627 5.75008C38.9212 5.75008 39.7793 6.6082 39.7793 7.66675C39.7793 8.14024 39.6041 8.59698 39.2873 8.94892L33.5413 15.3334L39.2873 21.7179C39.9954 22.5047 39.9316 23.7166 39.1448 24.4247C38.7929 24.7415 38.3361 24.9168 37.8626 24.9168H13.416V5.75Z\" fill=\"#EF6327\"></path></g><defs><clipPath id=\"clip0_1577_15245\"><rect width=\"46\" height=\"46\" fill=\"white\"></rect></clipPath></defs></svg></div>", 1)
const _hoisted_4 = { class: "progress-text" }
const _hoisted_5 = { class: "progress-content w-100" }
const _hoisted_6 = {
  class: "w-100 d-flex justify-content-between align-items-center",
  style: {"margin-bottom":"14px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "progress-sub-text" }, "Progress", -1)
const _hoisted_8 = { class: "progress-label" }
const _hoisted_9 = ["aria-valuenow"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, "Goal for " + _toDisplayString(_ctx.max) + " Agencies to be signed up", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.progress) + " out of " + _toDisplayString(_ctx.max), 1)
      ]),
      _createElementVNode("div", {
        class: "progress",
        role: "progressbar",
        "aria-label": "Danger example",
        "aria-valuenow": _ctx.percentage,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }, [
        _createElementVNode("div", {
          class: "progress-bar bg-red",
          style: _normalizeStyle(`width: ${_ctx.percentage}%`)
        }, null, 4)
      ], 8, _hoisted_9)
    ])
  ]))
}